export default (url2x, url3x) => `${url2x} 2x, ${url3x} 3x`;
